import { React, useState, useEffect, useContext } from 'react'
import DeleteModal from 'src/components/DeleteModal/DeleteModal'
import { CCard, CButton } from '@coreui/react'
import ServiceNotAllowed from '../serviceNotAllowed'
import StaticPageNameModal from './staticPageNameModal'
import { AppContext } from '../../context/app'
import { checkPermissions, createPageUrl, isEmpty, raiseToast } from 'src/views/utils/helper'
import { useHistory } from 'react-router-dom'
import CardListComponent from './cardListComponent'
import PlusIcon from '../../../assets/plus-icon.svg'
import { CUSTOM_PAGES_API } from 'src/views/utils/urls'
import useAxios from 'axios-hooks'
import moment from 'moment'
import ShareModal from '../../../components/shareModal'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { GlobalContext } from 'src/views/context/GlobalState'

const StaticPageListing = () => {
  const history = useHistory()
  const { setLoader, accountObj } = useContext(AppContext)
  const [deleteModal, setDeleteModal] = useState(false)
  const [staticPageNameModal, setStaticPageNameModal] = useState(false)
  const [pagesData, setPagesData] = useState([])
  const [shareModalData, setShareModalData] = useState([])
  const [pageId, setPageId] = useState('')

  const language = localStorage.getItem('language')
  const { userSessionObj } = useContext(GlobalContext)

  const defaultLangCheck = language === accountObj?.default_language
  const isCreateAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.WEBSITE.CREATE) &&
    defaultLangCheck

  let isCustomTemplateAllowed = accountObj?.od_resource_allowances?.custom_template
  const [{ data: pagesList, loading: pagesListLoading }, pagesListCall] = useAxios(
    {
      url: CUSTOM_PAGES_API,
      method: 'get',
    },
    { manual: true },
  )
  const [{ data: pageDelete, loading: pageDeleteLoading }, pageDeleteCall] = useAxios(
    {
      url: CUSTOM_PAGES_API,
      method: 'delete',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(pagesListLoading || pageDeleteLoading)
  }, [pagesListLoading, pageDeleteLoading])

  useEffect(() => {
    pagesListCall()
  }, [])

  useEffect(() => {
    if (pageDelete && pageDelete.success) {
      setDeleteModal(false)
      raiseToast('success', 'Deleted successfully')
      pagesListCall()
    }
  }, [pageDelete])

  useEffect(() => {
    if (pagesList && pagesList.success) {
      setPagesData(pagesList.data.filter((page) => page?.type === 'STATIC'))
    }
  }, [pagesList])

  const onEdit = (id) => {
    if (!isCustomTemplateAllowed) {
      raiseToast('error', "You don't have Access to Custom Template!")
      return
    }
    if (id) {
      history.push(`/static-editor/${id}`)
    }
  }

  const shareHandler = (info) => {
    setShareModalData([
      {
        title: 'Page URL',
        data: createPageUrl(accountObj?.domain_name, info?.page_url, '/static'),
      },
    ])
  }

  const handleDelete = () => {
    if (!isCustomTemplateAllowed) {
      raiseToast('error', "You don't have Access to Custom Template!")
      return
    }
    if (pageId) {
      pageDeleteCall({
        params: {
          custom_page_id: pageId,
        },
      })
    }
  }

  return (
    <>
      {isCustomTemplateAllowed ? (
        <div>
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <h4 style={{ marginTop: '5px' }}>Static Pages</h4>
              <p style={{ fontSize: '18px', color: '#707070' }}>
                Choose your website page and customize it as per your needs.{' '}
              </p>
            </div>
            <CButton
              style={{ border: '1px solid black', fontSize: '.75rem', marginTop: '10px' }}
              className="ml-2 bg-black rounded-1 btn-focus-none px-4"
              type="submit"
              onClick={
                isCustomTemplateAllowed
                  ? () => setStaticPageNameModal(true)
                  : () => raiseToast('error', "You don't have Access to Custom Template!")
              }
              disabled={!isCreateAllowed}
            >
              Add New Page
            </CButton>
          </div>
          <CCard
            className="rounded-0 cards-container scrollbar position-relative"
            style={{
              padding: '4.2% 2.5%',
              height: '45rem',
            }}
          >
            <div
              className="d-flex justify-content-center align-items-center bg-black text-white position-absolute rounded-1"
              style={{
                fontSize: 'max(1vw,14px)',
                gap: '0 2.2%',
                padding: '2px .6vw',
                top: 'max(1.1vw,20px)',
                left: '50%',
                transform: 'translateX(-50%)',
                right: '0',
                zIndex: '1',
                width: '95%',
              }}
            >
              <div
                className="d-flex justify-content-between align-items-center"
                style={{ width: '100%', fontWeight: '600' }}
              >
                <p style={{ marginBlockEnd: '0', width: '40%' }}>Page Title</p>
                <p style={{ marginBlockEnd: '0', width: '40%' }}>Page URL</p>
                <p style={{ marginBlockEnd: '0', width: '12%' }}>Last Modified</p>
                <div style={{ width: '5%' }}></div>
              </div>
            </div>
            <div className="pt-2">
              {pagesData.map((info) => (
                <CardListComponent
                  key={info._id}
                  id={info._id}
                  pageTitle={info?.name}
                  pageUrl={createPageUrl(accountObj?.domain_name, info?.page_url, '/static')}
                  mappedToTemplate={info?.mappedToTemplate}
                  lastModified={moment(info?.modified_date).format('DD MMMM YYYY')}
                  cardStyle={{ marginBottom: '.84vw', aspectRatio: '1388/71' }}
                  onEdit={onEdit}
                  onShare={() => shareHandler(info)}
                  onDelete={() => {
                    setPageId(info._id)
                    setDeleteModal(true)
                  }}
                />
              ))}
            </div>
            <div
              className="overflow-hidden bg-[#ececec] rounded  w-full flex flex-col justify-center items-center cursor-pointer flex-shrink-0 p-3 mt-1 mb-2"
              style={{
                borderRadius: '10px',
              }}
              onClick={
                isCreateAllowed
                  ? isCustomTemplateAllowed
                    ? () => setStaticPageNameModal(true)
                    : () => raiseToast('error', "You don't have Access to Custom Template!")
                  : () => raiseToast('error', 'Creation only allowed in default language!')
              }
            >
              <div
                className="h-[24px] w-[24px] rounded-full bg-[#191919] flex justify-center items-center shadow"
                style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
              >
                <img src={PlusIcon} className="w-[15px] h-[15px]" alt="trashicon" />
              </div>
              <p className="text-sm font-medium mb-0">Add new Page</p>
            </div>
          </CCard>
          {staticPageNameModal && (
            <StaticPageNameModal
              pagesData={pagesData}
              onCancel={() => setStaticPageNameModal(false)}
            />
          )}
          {deleteModal && (
            <DeleteModal
              openModal={deleteModal}
              title={`Are you sure you want to Delete this Page?`}
              confirmButtonText={`Yes`}
              onCancel={() => {
                setPageId('')
                setDeleteModal(false)
              }}
              onConfirm={handleDelete}
            />
          )}
          {!isEmpty(shareModalData) && (
            <ShareModal
              details={shareModalData}
              onClose={() => setShareModalData([])}
              modalTitle={'Share Page'}
            />
          )}
        </div>
      ) : (
        <ServiceNotAllowed />
      )}
    </>
  )
}

export default StaticPageListing
